import React from "react";
import { Mail, Linkedin, Phone } from "lucide-react";
import adv1 from "../../assets/images/Team/ritika.webp";
import adv2 from "../../assets/images/Team/prasoon.webp";
import adv3 from "../../assets/images/Team/Abhishek.jpeg";
import adv4 from "../../assets/images/Team/Anmol.jpeg";

// Aap yahan apne dono Team ki details fill kar sakte hain
const TeamData = [
  {
    id: 1,
    name: "Adv. Ritika Gautam",
    designation: "Managing Partner & Litigation Head",
    image: adv1,
    bio: `Ms. Ritika Gautam is the Managing Partner and Litigation Head of R & P Law Partners. She specializes in criminal, matrimonial and various other legal disputes, representing clients before the Supreme Court of India, various High Courts, Tribunals, Commissions and District Courts across Delhi NCR. Known for her strategic approach and strong advocacy, she is committed to delivering effective legal solutions tailored to the unique needs of each client. Her client-centric philosophy is built on transparency, trust, and long-term professional relationships.`,
    email: "partner2@rplawTeam.com",
    phone: "+91-9661900233",
    linkedin: "https://linkedin.com/in/partner2",
  },
  {
    id: 2,
    name: "Adv. K. Prasoon Ranjan",
    designation: "Founder Partner & Litigation Strategist",
    // Agar image hai to yahan path dalein, warna placeholder use hoga
    image: adv2,
    bio: `Mr. K. Prasoon Ranjan is the Founder Partner of R & P Law Partners with extensive experience in litigation and dispute resolution. His expertise spans criminal, matrimonial, civil and various other legal disputes. He is known for his strategic approach, practical legal solutions and unwavering commitment to protecting the interests of his clients. Through his dedication to excellence and client-focused representation, he has successfully handled complex legal matters across different forums and jurisdictions.`,
    email: "partner1@rplawTeam.com",
    phone: "+91-9953311115",
    linkedin: "https://linkedin.com/in/partner1",
  },
  {
    id: 3,
    name: "Adv. Abhishek Sharma",
    designation: "Founder Partner ",
    image: adv3,
    bio: "Mr. Abhishek Sharma is the Founder Partner of R & P Law Partners with extensive experience in litigation and dispute resolution. His areas of expertise include real estate, intellectual property rights, trademarks, copyrights and debt recovery cases. He is known for his practical legal approach and commitment to providing effective legal solutions tailored to the specific needs of his clients.",
    email: "partner2@rplawTeam.com",
    phone: "+91-9661900233",
    linkedin: "https://linkedin.com/in/partner2",
  },
  {
    id: 4,
    name: "Adv. Anmol R. Joshi",
    designation: "Senior Partner & Principal Counsel",
    image: adv4,
    bio: "Mr. Anmol R. Joshi is a Senior Partner & Principal Counsel at R & P Law Partners, specializing in litigation and regulatory advisory across Delhi-NCR and a member of the Supreme Court Bar Association, he practices before the Delhi High Court, Supreme Court, NCLT, and other tribunals. His broad expertise spans constitutional, commercial, insolvency, criminal, and matrimonial law. Committed to practical, strategic solutions, Anmol prioritizes careful analysis and active mediation or negotiated settlements to resolve matters effectively outside the courtroom whenever possible.",
    email: "partner2@rplawTeam.com",
    phone: "+91-9661900233",
    linkedin: "https://linkedin.com/in/partner2",
  },
];

const TeamhipSection = () => {
  // Br and colors tailored for the white theme
  const brandColors = {
    bgWhite: "#FFFFFF",
    blackPrimary: "#1A1A1A",
    textGray: "#4A4A4A",
    crimson: "#A10F1A",
    gold: "#C79A3B",
  };

  return (
    <section className="py-24 px-6 md:px-12 bg-white relative overflow-hidden">
      {/* Background Watermark */}
      <div
        className="absolute top-10 left-1/2 -translate-x-1/2 pointer-events-none select-none z-0"
        style={{
          fontFamily: "'Cinzel', serif",
          fontSize: "120px",
          fontWeight: 700,
          color: "rgba(26, 26, 26, 0.02)",
          lineHeight: 1,
          textTransform: "uppercase",
          whiteSpace: "nowrap",
        }}
      >
        LEADERSHIP
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        {/* SECTION HEADER */}
        <div className="mb-20 text-center flex flex-col items-center">
          <div className="flex items-center gap-3 mb-4">
            <span
              style={{
                width: "40px",
                height: "1px",
                background: `linear-gradient(270deg, ${brandColors.crimson}, transparent)`,
              }}
            />
            <span
              style={{
                fontFamily: "'Cinzel', serif",
                fontSize: "12px",
                letterSpacing: "0.25em",
                color: brandColors.crimson,
                textTransform: "uppercase",
                fontWeight: 600,
              }}
            >
              Our Founders
            </span>
            <span
              style={{
                width: "40px",
                height: "1px",
                background: `linear-gradient(90deg, ${brandColors.crimson}, transparent)`,
              }}
            />
          </div>
          <h2
            style={{
              fontFamily: "'Cinzel', serif",
              color: brandColors.blackPrimary,
            }}
            className="text-4xl md:text-5xl font-bold uppercase tracking-wide"
          >
            Meet The <span style={{ color: brandColors.gold }}>Team</span>
          </h2>
          <div className="mt-6 flex items-center justify-center gap-3">
            <div
              style={{
                width: "6px",
                height: "6px",
                border: `1px solid ${brandColors.gold}`,
                transform: "rotate(45deg)",
              }}
            />
            <div
              style={{
                width: "100px",
                height: "0.5px",
                background: `linear-gradient(90deg, ${brandColors.gold}, transparent)`,
              }}
            />
          </div>
        </div>

        {/* Team GRID */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-20">
          {TeamData.map((partner) => (
            <div key={partner.id} className="group relative flex flex-col">
              {/* Image Container with Hover Effect */}
              <div
                className="relative overflow-hidden mb-8 border"
                style={{
                  borderColor: "rgba(26, 26, 26, 0.08)",
                  aspectRatio: "3/4", // Gives a professional portrait look
                }}
              >
                {/* Decorative Frame Line */}
                <div
                  className="absolute inset-4 z-10 pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                  style={{ border: `1px solid ${brandColors.gold}` }}
                />

                {/* Image Gradient Overlay */}
                <div className="absolute inset-0 z-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

                <img
                  src={partner.image}
                  alt={partner.name}
                  className="w-full h-full object-cover grayscale-[20%] group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
                />
              </div>

              {/* Content Area */}
              <div className="flex flex-col text-center md:text-left">
                <h3
                  style={{
                    fontFamily: "'Cinzel', serif",
                    color: brandColors.blackPrimary,
                  }}
                  className="text-3xl font-bold uppercase tracking-wide mb-2 group-hover:text-[#A10F1A] transition-colors"
                >
                  {partner.name}
                </h3>

                <h4
                  style={{ color: brandColors.gold }}
                  className="text-sm font-bold uppercase tracking-[0.2em] mb-6"
                >
                  {partner.designation}
                </h4>

                <p
                  style={{
                    fontFamily: "'Cormorant Garamond', serif",
                    color: brandColors.textGray,
                  }}
                  className="text-lg leading-relaxed mb-8 font-medium flex-grow text-justify"
                >
                  {partner.bio}
                </p>

                {/* Contact Links */}
                <div className="flex items-center justify-center md:justify-start gap-4 mt-auto">
                  {/* <a 
                    href={`mailto:${partner.email}`}
                    className="w-10 h-10 rounded-full border flex items-center justify-center transition-all duration-300 hover:-translate-y-1"
                    style={{ borderColor: "rgba(26,26,26,0.1)", color: brandColors.blackPrimary }}
                    onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = brandColors.crimson; e.currentTarget.style.color = brandColors.bgWhite; e.currentTarget.style.borderColor = brandColors.crimson; }}
                    onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.color = brandColors.blackPrimary; e.currentTarget.style.borderColor = "rgba(26,26,26,0.1)"; }}
                  >
                    <Mail size={16} />
                  </a> */}

                  {/* <a 
                    href={`tel:${partner.phone}`}
                    className="w-10 h-10 rounded-full border flex items-center justify-center transition-all duration-300 hover:-translate-y-1"
                    style={{ borderColor: "rgba(26,26,26,0.1)", color: brandColors.blackPrimary }}
                    onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = brandColors.gold; e.currentTarget.style.color = brandColors.bgWhite; e.currentTarget.style.borderColor = brandColors.gold; }}
                    onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.color = brandColors.blackPrimary; e.currentTarget.style.borderColor = "rgba(26,26,26,0.1)"; }}
                  >
                    <Phone size={16} />
                  </a> */}

                  {/* <a 
                    href={partner.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 rounded-full border flex items-center justify-center transition-all duration-300 hover:-translate-y-1"
                    style={{ borderColor: "rgba(26,26,26,0.1)", color: brandColors.blackPrimary }}
                    onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "#0077B5"; e.currentTarget.style.color = brandColors.bgWhite; e.currentTarget.style.borderColor = "#0077B5"; }}
                    onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.color = brandColors.blackPrimary; e.currentTarget.style.borderColor = "rgba(26,26,26,0.1)"; }}
                  >
                    <Linkedin size={16} />
                  </a> */}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamhipSection;
